import api from './api';

export const getPrescriptions = async (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value);
    }
  });
  const response = await api.get(`/prescriptions?${query.toString()}`);
  return response.data;
};

export const getPrescriptionByAppointmentId = async (appointmentId) => {
  const response = await api.get(`/prescriptions/appointment/${appointmentId}`);
  return response.data;
};

export const getPrescriptionById = async (id) => {
  const response = await api.get(`/prescriptions/${id}`);
  return response.data;
};

export const downloadPrescriptionPDF = async (id) => {
  const response = await api.get(`/prescriptions/${id}/pdf`, {
    responseType: 'blob'
  });
  return response;
};

export const createPrescription = async (data) => {
  const response = await api.post('/prescriptions', data);
  return response.data;
};

export const submitPrescription = async (id, data = {}) => {
  const response = await api.post(`/prescriptions/${id}/submit`, data);
  return response.data;
};

export const verifyPrescription = async (id, data) => {
  const response = await api.post(`/prescriptions/${id}/verify`, data);
  return response.data;
};

export const sendPrescriptionToLead = async (id, data = {}) => {
  const response = await api.post(`/prescriptions/${id}/send-to-lead`, data);
  return response.data;
};

export const updatePrescription = async (id, data) => {
  const response = await api.patch(`/prescriptions/${id}`, data);
  return response.data;
};

export const deletePrescription = async (id) => {
  const response = await api.delete(`/prescriptions/${id}`);
  return response.data;
};

export const sendPrescriptionFormToDoctor = async (id) => {
  const response = await api.post(`/prescriptions/${id}/send-form-to-doctor`);
  return response.data;
};